import { cn } from '@vimond/theme/tailwind';

const Loading = ({ className = '' }) => {
  return (
    <div
      className={cn(
        'flex h-screen items-center justify-center space-x-2 bg-background-primary',
        className,
      )}
    >
      <div className="h-6 w-6 animate-bounce rounded-full bg-text-highlight [animation-delay:-0.3s]"></div>
      <div className="h-6 w-6 animate-bounce rounded-full bg-text-highlight [animation-delay:-0.15s]"></div>
      <div className="h-6 w-6 animate-bounce rounded-full bg-text-highlight"></div>
    </div>
  );
};
export default Loading;
